import { Stack, Text } from '@talos/kyoko';

export type SelectedFieldTooltipContentProps = {
  title: string;
  lines: string[];
  emptyMessage?: string;
};

export function SelectedFieldTooltipContent({ title, lines, emptyMessage }: SelectedFieldTooltipContentProps) {
  const body =
    lines.length > 0 ? (
      lines.map((line, index) => (
        <Text key={index} color="colorTextHighlight">
          {line}
        </Text>
      ))
    ) : (
      <Text color="colorTextHighlight">{emptyMessage ?? '—'}</Text>
    );

  return (
    <Stack gap="spacing8" alignItems="stretch">
      <Text fontWeight="500" color="colorTextImportant">
        {title}
      </Text>
      <Stack gap="spacing4">{body}</Stack>
    </Stack>
  );
}
